(function () {
  'use strict';

  var POLICY_URL = 'https://perdomodistributor.com/pages/warranty-policy';
  var WARRANTY_URL = 'https://perdomodistributor.com/pages/warranty';
  var REDIRECT_SECONDS = 8;

  // Validation rules. JS RegExp on purpose: pattern="" compiles with the v flag
  // and rejects classes like [().-]. Never put // inside a regex (minifier).
  var EMAIL = /^\w[\w.+-]*@(\w+(-\w+)*\.)+[A-Za-z]{2,22}$/;
  var PHONE = /^\+?(?:[\s().-]*\d){10,15}[\s().-]*$/;
  var SERIAL = /^[A-Za-z0-9-]{6,30}$/;
  var FILE_TYPES = /\.(jpe?g|png|gif|webp|heic|heif|pdf)$/i;
  var FILE_ACCEPT = 'image/*,.heic,.heif,.pdf';
  var FILE_MAX_MB = 20;
  var MSG = {
    email: 'Enter a valid email address.',
    tel: 'Enter a valid phone number.',
    serial: 'Use 6–30 letters, digits or hyphens, no spaces.',
    anyOf: 'Enter at least one serial number.',
    anyOfHelp: 'At least one serial number is required.',
    attach: 'Attach at least one photo of the serial number label.',
    attachMini: 'Attach photos of the serial number labels of both units, indoor and outdoor.',
    fileType: 'Only photos (JPG, PNG, HEIC, WebP, GIF) or PDF files can be attached.',
    fileSize: 'Each file must be ' + FILE_MAX_MB + ' MB or smaller.',
    date: 'Enter a valid date, not in the future.',
    terms: 'Please read and accept the Warranty Terms and Conditions.'
  };
  // Serial help: illustrated box label uploaded to Shopify Files (files/zs-serial-label.svg).
  var SERIAL_TIP = 'Find it on the label on the box or on the side of the unit (indoor and outdoor units each have their own). Enter the number under the barcode exactly as shown.';
  var SERIAL_IMG = '/cdn/shop/files/zs-serial-label.svg';
  // Customer fields only; technician fields must not autofill the customer's data.
  var AUTOCOMPLETE = {
    'First Name': 'given-name',
    'Contact Name': 'family-name',
    Email: 'email',
    Phone: 'tel',
    'Installation Address': 'street-address'
  };

  var REVIEW =
    '. Our team will review it within 3 business days and email you with next steps, including any additional information we need.';

  var FORMS = {
    zsWebToCase_1435062000000477035: {
      kind: 'claims',
      title: 'Warranty Claim',
      groups: {
        'First Name': 'Your details',
        Brand: 'Product',
        Subject: 'Issue',
        'Intake Agent': 'Staff use'
      },
      // Zoho places new fields above Attachment; staff fields go last, and
      // their Zoho help shows behind an info icon instead of inline text.
      lastFields: ['Intake Agent'],
      tipFields: ['Intake Agent'],
      successTitle: 'Claim submitted',
      successBody: "Thank you, we've received your warranty claim" + REVIEW,
      emailFields: ['Email'],
      telFields: ['Phone'],
      serialFields: ['Serial Number'],
      attachMin: 1,
      attachLabel: 'Serial number photos',
      attachButton: 'Attach photos',
      attachHelp:
        'Attach a clear, readable photo of the serial number label (the sticker on the unit). We use it to verify the warranty.',
      attachHint: {
        field: 'Product Type',
        value: 'Mini Split',
        text: 'Mini Split: attach the serial number labels of both units, indoor and outdoor.'
      },
      frameTitle: 'Claim submission'
    },
    zsWebToCase_1435062000000702684: {
      kind: 'registration',
      title: 'Warranty Registration',
      groups: {
        Subject: 'Your details',
        'Purchase Via': 'Purchase & installation',
        "Technician's full name": 'Technician',
        'Product Type': 'Product'
      },
      successTitle: 'Registration submitted',
      successBody: "Thank you, we've received your warranty registration" + REVIEW,
      emailFields: ['Email', "Technician's email"],
      telFields: ['Phone', "Technician's phone number"],
      // Every visible field is mandatory on registrations, except the serials:
      // at least one of the two.
      required: [
        'First Name',
        'Phone',
        'Purchase Via',
        'Installation Date',
        'Installation Address',
        "Technician's full name",
        "Technician's email",
        "Technician's phone number",
        "Technician's address",
        "Technician's business / company name",
        'Licence Type',
        'Licence Number',
        "Institution that issued Technician's Licence",
        'Product Brand',
        'Product Type',
        'Product Model'
      ],
      anyOf: [['Indoor Serial Number', 'Outdoor Serial Number']],
      serialFields: ['Indoor Serial Number', 'Outdoor Serial Number'],
      attachMin: 1,
      attachLabel: 'Serial number photos',
      attachButton: 'Attach photos',
      attachHelp:
        'Attach a clear, readable photo of the serial number label (the sticker on the unit). It helps us register the warranty correctly.',
      attachHint: {
        field: 'Product Type',
        value: 'Mini Split',
        text: 'Mini Split: attach the serial number labels of both units, indoor and outdoor.'
      },
      frameTitle: 'Registration submission'
    }
  };

  var CARET =
    '<span class="svg-wrapper"><svg aria-hidden="true" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z" fill="currentColor"></path></svg></span>';

  var ICON_SUCCESS =
    '<span class="svg-wrapper zs-success__icon" aria-hidden="true"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"/><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"/></svg></span>';

  var ICON_ERROR =
    '<svg class="icon icon-error" viewBox="0 0 13 13" aria-hidden="true"><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B"/><path fill="#fff" d="M6 3.4h1.1l.1 4.2H5.9L6 3.4zm.55 6.2a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4z"/></svg>';

  var ICON_INFO =
    '<span class="svg-wrapper"><svg class="icon icon-info" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" stroke-width="1.2"/><path fill="currentColor" d="M9.3 8.6h1.4v5.6H9.3zM10 5.4a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8z"/></svg></span>';

  var uid = 0;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Local calendar date; toISOString() is UTC and allows tomorrow in US evenings.
  function localToday() {
    var d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  }

  function isHidden(tr) {
    return /display\s*:\s*none/.test(tr.getAttribute('style') || '');
  }

  function stripLeading(td) {
    var text = '';
    while (td.firstChild) {
      var node = td.firstChild;
      if (node.nodeType === 3) {
        text += node.textContent;
        node.remove();
        continue;
      }
      if (node.nodeType === 1 && node.tagName === 'BR') {
        node.remove();
        continue;
      }
      break;
    }
    return text.replace(/\s+/g, ' ').trim();
  }

  function helpText(td) {
    var icon = td.querySelector('.wtchelpinfo');
    if (!icon) return '';
    var match = /showtt\(.([^\x22]+)/.exec(icon.getAttribute('onmouseover') || '');
    icon.remove();
    return match ? match[1] : '';
  }

  function addHelp(td, text) {
    if (!text) return;
    var span = document.createElement('span');
    span.className = 'zs-help';
    span.textContent = text;
    td.appendChild(span);
  }

  // Toggletip: the theme's .field__button inside the input. Hover shows it on
  // pointer devices; click/tap toggles; Escape, blur or a click outside close it.
  function addTip(field, control, labelText, text, img) {
    if (!text) return;
    var tip = document.createElement('span');
    tip.className = 'zs-tip';
    var bubble = document.createElement('span');
    bubble.className = 'zs-tip__text global-settings-popup';
    bubble.id = control.id + '-tip';
    bubble.setAttribute('role', 'tooltip');
    bubble.textContent = text;
    if (img) {
      bubble.insertAdjacentHTML('afterbegin', '<img class="zs-tip__img" src="' + img + '" alt="Box label with the serial number under the barcode" width="480" height="280">');
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'field__button zs-tip__button';
    button.setAttribute('aria-label', 'About ' + labelText);
    button.setAttribute('aria-describedby', bubble.id);
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = ICON_INFO;
    control.setAttribute('aria-describedby', bubble.id);
    var toggle = function (open) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    button.addEventListener('click', function () {
      toggle(button.getAttribute('aria-expanded') !== 'true');
    });
    button.addEventListener('blur', function () { toggle(false); });
    tip.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') toggle(false);
    });
    document.addEventListener('click', function (event) {
      if (!tip.contains(event.target)) toggle(false);
    });
    tip.appendChild(button);
    tip.appendChild(bubble);
    field.classList.add('zs-has-tip');
    field.appendChild(tip);
  }

  function ensureId(el) {
    if (!el.id) {
      el.id = 'zsf-' + (++uid) + '-' + (el.name || '').replace(/\W+/g, '-');
    }
    return el.id;
  }

  function labelOf(control) {
    var label = control.labels && control.labels[0];
    return label ? label.textContent.replace('*', '').trim() : 'This field';
  }

  function isEmpty(control) {
    var value = (control.value || '').trim();
    return !value || (control.tagName === 'SELECT' && value === '-None-');
  }

  function focusControl(el) {
    if (!el) return;
    (el.querySelector('[tabindex], input, select, textarea') || el).focus();
    el.scrollIntoView({ block: 'center' });
  }

  function markRequired(td, control) {
    if (control) control.required = true;
    var label = td.querySelector('label, .form__label');
    if (label) label.insertAdjacentHTML('beforeend', '<span class="zs-req" aria-hidden="true">*</span>');
  }

  function setFieldError(control, message) {
    var id = ensureId(control) + '-error';
    var err = document.getElementById(id);
    if (!err) {
      if (!message) return;
      err = document.createElement('small');
      err.id = id;
      err.className = 'form__message zs-field-error';
      err.innerHTML = ICON_ERROR + '<span></span>';
      (control.closest('.field, .select, .zs-attach, .zs-terms') || control).insertAdjacentElement('afterend', err);
    }
    err.querySelector('span').textContent = message;
    var wrap = control.closest('.field, .select');
    if (wrap) wrap.classList.toggle('zs-invalid', !!message);
    if (message) {
      err.removeAttribute('hidden');
      control.setAttribute('aria-invalid', 'true');
      control.setAttribute('aria-describedby', id);
    } else {
      err.setAttribute('hidden', '');
      control.removeAttribute('aria-invalid');
      control.removeAttribute('aria-describedby');
    }
  }

  function checkControl(control, cfg) {
    if (control.type === 'checkbox') return control.required && !control.checked ? MSG.terms : '';
    var v = control.validity;
    if (control.type === 'date' && v && (v.badInput || v.rangeOverflow)) return MSG.date;
    if (isEmpty(control)) return control.required ? labelOf(control) + ' is required.' : '';
    var value = control.value.trim();
    if (control.type === 'email' && !EMAIL.test(value)) return MSG.email;
    if (control.type === 'tel' && !PHONE.test(value)) return MSG.tel;
    if (cfg.serialFields.indexOf(control.name) > -1 && !SERIAL.test(value)) return MSG.serial;
    return '';
  }

  function attachedCount(form) {
    var n = 0;
    form.querySelectorAll('input.wtcuploadinput').forEach(function (input) {
      if (input.files && input.files.length) n++;
    });
    return n;
  }

  // Flags every invalid control inline; returns the first one in DOM order.
  function validateForm(form, cfg) {
    form
      .querySelectorAll('input:not([type=hidden]):not([type=file]), select, textarea')
      .forEach(function (el) {
        setFieldError(el, checkControl(el, cfg));
      });
    (cfg.anyOf || []).forEach(function (names) {
      var els = names.map(function (name) { return form.elements[name]; }).filter(Boolean);
      var filled = els.some(function (el) { return el.value.trim(); });
      if (!filled) els.forEach(function (el) { setFieldError(el, MSG.anyOf); });
    });
    var attach = form.querySelector('.zs-attach');
    if (attach && cfg.attachMin) {
      var hint = cfg.attachHint && form.elements[cfg.attachHint.field];
      var mini = hint && hint.value === cfg.attachHint.value;
      setFieldError(attach, attachedCount(form) < cfg.attachMin ? (mini ? MSG.attachMini : MSG.attach) : '');
    }
    return form.querySelector('[aria-invalid="true"]');
  }

  function floatField(td, control, labelText, asTip, serial) {
    var help = serial ? SERIAL_TIP : helpText(td);
    control.classList.add('field__input');
    if (control.tagName === 'TEXTAREA') control.classList.add('text-area');
    control.setAttribute('placeholder', ' ');
    ensureId(control);
    var field = document.createElement('div');
    field.className = 'field';
    td.insertBefore(field, control);
    field.appendChild(control);
    var label = document.createElement('label');
    label.className = 'field__label';
    label.htmlFor = control.id;
    label.textContent = labelText;
    field.appendChild(label);
    if (asTip || serial) addTip(field, control, labelText, help, serial && SERIAL_IMG);
    else addHelp(td, help);
    return field;
  }

  function selectField(td, select, labelText) {
    var help = helpText(td);
    ensureId(select);
    select.classList.add('select__select');
    var wrap = document.createElement('div');
    wrap.className = 'select';
    td.insertBefore(wrap, select);
    wrap.appendChild(select);
    wrap.insertAdjacentHTML('beforeend', CARET);
    var label = document.createElement('label');
    label.className = 'field__label';
    label.htmlFor = select.id;
    label.textContent = labelText;
    wrap.appendChild(label);
    var sync = function () {
      wrap.classList.toggle('has-value', select.value !== '-None-');
    };
    select.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync();
    addHelp(td, help);
  }

  function toButton(input, className, type) {
    var button = document.createElement('button');
    button.type = type;
    button.className = className;
    button.textContent = input.value;
    if (input.id) button.id = input.id;
    var onclick = input.getAttribute('onclick');
    if (onclick) button.setAttribute('onclick', onclick);
    input.replaceWith(button);
    return button;
  }

  function termsField(kind) {
    var wrap = document.createElement('div');
    wrap.className = 'zs-terms';
    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'zsWarrantyTerms-' + kind;
    checkbox.required = true;
    checkbox.setAttribute('aria-required', 'true');
    var label = document.createElement('label');
    label.className = 'zs-terms__label';
    label.htmlFor = checkbox.id;
    label.appendChild(
      document.createTextNode('By checking this box, I acknowledge and accept the ')
    );
    var link = document.createElement('a');
    link.href = POLICY_URL;
    link.className = 'link underlined-link';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Warranty Terms and Conditions';
    link.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    label.appendChild(link);
    wrap.appendChild(checkbox);
    wrap.appendChild(label);
    return wrap;
  }

  // Read-to-accept: when the embed renders the policy into #zsTermsText, ticking
  // the box opens it in a dialog; Accept unlocks only after scrolling to the end.
  function termsDialog(root, checkbox) {
    var tpl = document.getElementById('zsTermsText');
    if (!tpl || !tpl.innerHTML.trim()) return;
    var dialog = document.createElement('dialog');
    dialog.className = 'zs-dialog';
    dialog.setAttribute('aria-labelledby', 'zsTermsTitle');
    // Outside the Zoho form, so plain <button>s don't submit anything.
    dialog.innerHTML =
      '<div class="zs-dialog__head"><h2 class="h2" id="zsTermsTitle">Warranty Terms and Conditions</h2>' +
      '<button class="zs-dialog__close" aria-label="Close">&times;</button></div>' +
      '<div class="zs-dialog__body rte" tabindex="0"></div><div class="zs-dialog__bar"><span></span></div>' +
      '<div class="zs-dialog__status caption"><span aria-live="polite"></span><span></span></div>' +
      '<button class="button">Accept Terms</button>';
    var body = dialog.querySelector('.zs-dialog__body');
    body.appendChild(tpl.content.cloneNode(true));
    body.insertAdjacentHTML('beforeend', '<p class="zs-dialog__end caption">End of terms</p>');
    var bar = dialog.querySelector('.zs-dialog__bar span');
    var status = dialog.querySelectorAll('.zs-dialog__status span');
    var accept = dialog.querySelector('.button');
    var read = false;
    var update = function () {
      var left = body.scrollHeight - body.scrollTop - body.clientHeight;
      read = read || left < 2;
      var pct = read ? 100 : Math.min(99, Math.round((body.scrollTop + body.clientHeight) / body.scrollHeight * 100));
      bar.style.width = pct + '%';
      status[0].textContent = read ? "\u2713 You've reached the end" : '\u2193 Scroll to the end to enable';
      status[1].textContent = pct + '% read';
      accept.setAttribute('aria-disabled', read ? 'false' : 'true');
    };
    body.addEventListener('scroll', update);
    checkbox.addEventListener('click', function (event) {
      if (!checkbox.checked) return;
      event.preventDefault();
      dialog.showModal();
      update();
    });
    dialog.querySelector('button').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { checkbox.focus(); });
    accept.addEventListener('click', function () {
      if (!read) return;
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      dialog.close();
    });
    root.appendChild(dialog);
  }

  function visibleFileInput(root) {
    var inputs = root.querySelectorAll('input.wtcuploadinput');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].style.display !== 'none') return inputs[i];
    }
    return null;
  }

  function layoutAttachments(root, form, td, cfg) {
    var wrap = document.createElement('div');
    wrap.className = 'zs-attach';
    var label = document.createElement('span');
    label.className = 'form__label';
    label.id = 'zsAttachLabel-' + cfg.kind;
    var zohoLabel = stripLeading(td);
    label.textContent = cfg.attachLabel || zohoLabel;
    wrap.appendChild(label);
    if (cfg.attachHelp) {
      var help = document.createElement('span');
      help.className = 'zs-help';
      help.textContent = cfg.attachHelp;
      wrap.appendChild(help);
    }
    if (cfg.attachHint) {
      var hint = document.createElement('span');
      hint.className = 'zs-help zs-hint';
      hint.textContent = cfg.attachHint.text;
      wrap.appendChild(hint);
      var source = cfg.attachHint.field && form.elements[cfg.attachHint.field];
      var updateHint = function () {
        hint.hidden = !!source && source.value !== cfg.attachHint.value;
      };
      if (source) source.addEventListener('change', updateHint);
      updateHint();
    }
    var browse = td.querySelector('#zsBrowseAttachment');
    if (cfg.attachButton) browse.textContent = cfg.attachButton;
    browse.classList.add('button', 'button--secondary');
    browse.setAttribute('role', 'button');
    browse.setAttribute('aria-labelledby', label.id);
    browse.tabIndex = 0;
    browse.addEventListener('click', function () {
      var input = visibleFileInput(root);
      if (input) input.click();
    });
    browse.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        browse.click();
      }
    });
    wrap.appendChild(browse);
    td.querySelectorAll('input.wtcuploadinput').forEach(function (input) {
      input.accept = FILE_ACCEPT;
      wrap.appendChild(input);
    });
    td.querySelectorAll('#zsMaxSizeMessage, #zsMaxLimitMessage').forEach(function (msg) {
      msg.removeAttribute('style');
      msg.className = 'zs-help';
      wrap.appendChild(msg);
    });
    var limitMsg = wrap.querySelector('#zsMaxLimitMessage');
    if (limitMsg) limitMsg.style.display = 'none';
    var files = td.querySelector('#zsFileBrowseAttachments');
    if (files) wrap.appendChild(files);
    while (td.firstChild) td.removeChild(td.firstChild);
    td.appendChild(wrap);
    if (cfg.attachMin) markRequired(td, null);
  }

  function showSuccess(root, form, cfg) {
    if (root.querySelector('.zs-success')) return;
    var banner = document.createElement('div');
    banner.className = 'zs-success is-visible';
    banner.id = 'zsSuccess-' + cfg.kind;
    banner.setAttribute('role', 'status');
    banner.setAttribute('aria-live', 'polite');
    banner.insertAdjacentHTML('afterbegin', ICON_SUCCESS);
    var heading = document.createElement('h2');
    heading.className = 'h2';
    heading.tabIndex = -1;
    heading.textContent = cfg.successTitle;
    banner.appendChild(heading);
    var body = document.createElement('p');
    body.className = 'zs-success__body';
    body.textContent = cfg.successBody;
    banner.appendChild(body);
    var continueLink = document.createElement('a');
    continueLink.className = 'button button--full-width';
    continueLink.href = WARRANTY_URL;
    continueLink.textContent = 'Continue to warranty page';
    banner.appendChild(continueLink);
    var countdown = document.createElement('p');
    countdown.className = 'zs-success__countdown caption';
    banner.appendChild(countdown);
    root.insertBefore(banner, root.firstChild);
    root.classList.add('is-submitted');
    form.setAttribute('inert', '');
    form.setAttribute('aria-hidden', 'true');
    var left = REDIRECT_SECONDS;
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function renderCount() {
      countdown.textContent =
        'Redirecting in ' + left + ' second' + (left === 1 ? '' : 's') + '…';
    }
    renderCount();
    banner.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    heading.focus();
    var timer = setInterval(function () {
      left -= 1;
      if (left <= 0) {
        clearInterval(timer);
        window.location.href = WARRANTY_URL;
        return;
      }
      renderCount();
    }, 1000);
    // Any interaction cancels the auto-redirect; the button stays.
    function stop() {
      clearInterval(timer);
      countdown.textContent = 'Use the button above when you are ready.';
    }
    continueLink.addEventListener('click', stop);
    ['keydown', 'pointerdown', 'wheel'].forEach(function (type) {
      document.addEventListener(type, stop, { once: true, passive: true });
    });
  }

  function wireSubmit(root, form, cfg) {
    var originalValidate = window.zsValidateMandatoryFields;
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    var submitLabel = submitBtn ? submitBtn.textContent || submitBtn.value : 'Submit';
    var pending = false;
    var ignoreLoad = true;
    var successTimer = 0;
    var frameName = 'zsDeskFrame-' + cfg.kind;

    var frame = document.createElement('iframe');
    frame.name = frameName;
    frame.id = frameName;
    frame.title = cfg.frameTitle;
    frame.setAttribute('data-zs-frame', cfg.kind);
    frame.setAttribute('aria-hidden', 'true');
    root.appendChild(frame);
    form.setAttribute('target', frameName);
    form.noValidate = true;
    var attempted = false;

    var returnInput = form.querySelector("input[name='returnURL']");
    if (returnInput) {
      returnInput.value = location.origin + '/cdn/shop/files/zs-claim-ok';
    }

    function setBusy(on) {
      if (!submitBtn) return;
      if (on) {
        submitBtn.setAttribute('disabled', 'disabled');
        if (submitBtn.tagName === 'BUTTON') submitBtn.textContent = 'Submitting…';
      } else {
        submitBtn.removeAttribute('disabled');
        if (submitBtn.tagName === 'BUTTON') submitBtn.textContent = submitLabel;
      }
    }

    function finishSuccess() {
      if (!pending) return;
      pending = false;
      ignoreLoad = true;
      if (successTimer) {
        clearTimeout(successTimer);
        successTimer = 0;
      }
      showSuccess(root, form, cfg);
    }

    window.zsValidateMandatoryFields = function () {
      if (pending) return false;
      attempted = true;
      var bad = validateForm(form, cfg);
      if (bad) {
        focusControl(bad);
        return false;
      }
      var ok = originalValidate ? originalValidate.apply(this, arguments) : true;
      if (ok === false) return false;
      pending = true;
      ignoreLoad = false;
      setBusy(true);
      if (successTimer) clearTimeout(successTimer);
      successTimer = setTimeout(finishSuccess, 1200);
      return true;
    };

    // After a failed submit the whole form re-checks live; before that, only a
    // control already flagged re-checks, and formats are checked on blur.
    function recheck(el) {
      if (attempted) {
        validateForm(form, cfg);
      } else if (el.getAttribute('aria-invalid')) {
        setFieldError(el, checkControl(el, cfg));
      }
    }
    form.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        var file = input.classList.contains('wtcuploadinput') && input.files && input.files[0];
        if (!file) return;
        var attach = form.querySelector('.zs-attach');
        var msg = !FILE_TYPES.test(file.name)
          ? MSG.fileType
          : file.size > FILE_MAX_MB * 1048576 ? MSG.fileSize : '';
        if (!msg) {
          if (attach) setFieldError(attach, '');
          return;
        }
        event.stopPropagation();
        input.value = '';
        if (attach) setFieldError(attach, msg);
      },
      true
    );
    ['input', 'change'].forEach(function (type) {
      form.addEventListener(type, function (event) {
        recheck(event.target);
      });
    });
    form.addEventListener('focusout', function (event) {
      var el = event.target;
      if (cfg.serialFields.indexOf(el.name) > -1) el.value = el.value.trim().toUpperCase();
      if (attempted || el.getAttribute('aria-invalid')) recheck(el);
      else if (el.type !== 'checkbox' && el.type !== 'file' && !isEmpty(el)) {
        setFieldError(el, checkControl(el, cfg));
      }
    });
    // Removing a file (the X link) runs Zoho's handler on document, after us.
    root.addEventListener('click', function (event) {
      if (attempted && event.target.classList.contains('zsfilebrowseAttachment')) {
        setTimeout(function () { recheck(event.target); }, 0);
      }
    });

    // Zoho posts into the iframe. The return document is usually unreadable
    // (desk.zoho.com or Shopify X-Frame-Options). After client validation,
    // iframe load or a short timer both mean the ticket was created — same
    // success banner and redirect for claims and registrations.
    frame.addEventListener('load', function () {
      if (ignoreLoad || !pending) return;
      finishSuccess();
    });
  }

  function transform(root, form, cfg) {
    var heading = form.querySelector('td[colspan] strong');
    if (heading) {
      var h2 = document.createElement('h2');
      h2.className = 'h2';
      h2.textContent = cfg.title || heading.textContent;
      heading.replaceWith(h2);
      h2.insertAdjacentHTML(
        'afterend',
        '<p class="zs-legend caption">Fields marked <span class="zs-req">*</span> are required.</p>'
      );
    }
    // Zoho's own mandatory list (zsWebFormMandatoryFields) plus our extras.
    var required = (window.zsWebFormMandatoryFields || []).concat(cfg.required || []);
    var anyNames = [].concat.apply([], cfg.anyOf || []);

    form.querySelectorAll('select option').forEach(function (option) {
      if (option.value === '-') {
        option.value = '-None-';
        option.textContent = '';
      }
    });

    cfg.emailFields.forEach(function (name) {
      if (form.elements[name]) form.elements[name].type = 'email';
    });
    cfg.telFields.forEach(function (name) {
      if (form.elements[name]) form.elements[name].type = 'tel';
    });

    var submitRow = form.querySelector("input[type='submit']");
    (cfg.lastFields || []).forEach(function (name) {
      var el = form.elements[name];
      if (el && submitRow) submitRow.closest('tr').before(el.closest('tr'));
    });

    form.querySelectorAll(':scope > br').forEach(function (br) {
      br.remove();
    });
    form.querySelectorAll('td[style]').forEach(function (td) {
      td.removeAttribute('style');
    });

    form.querySelectorAll('tr').forEach(function (tr) {
      if (isHidden(tr)) return;
      var td = tr.querySelector('td');
      if (td && td.querySelector('.wb_FtCon')) {
        tr.remove();
        return;
      }
      if (!td || td.querySelector('h2')) return;

      if (td.querySelector("input[type='submit']")) {
        var submit = td.querySelector("input[type='submit']");
        var actions = document.createElement('div');
        actions.className = 'zs-actions';
        var terms = termsField(cfg.kind);
        actions.appendChild(terms);
        termsDialog(root, terms.firstChild);
        actions.appendChild(toButton(submit, 'button button--full-width', 'submit'));
        td.textContent = '';
        td.appendChild(actions);
        return;
      }

      if (td.querySelector('#zsBrowseAttachment')) {
        layoutAttachments(root, form, td, cfg);
        return;
      }

      var control = td.querySelector(
        "select, textarea, input[type='text'], input[type='email'], input[type='tel'], input[type='date']"
      );
      if (!control) return;
      var labelText = stripLeading(td);
      if (control.tagName === 'SELECT') selectField(td, control, labelText);
      else floatField(td, control, labelText, (cfg.tipFields || []).indexOf(control.name) > -1, cfg.serialFields.indexOf(control.name) > -1);
      if (required.indexOf(control.name) > -1) markRequired(td, control);
      if (anyNames.indexOf(control.name) > -1) addHelp(td, MSG.anyOfHelp);
      if (AUTOCOMPLETE[control.name]) control.autocomplete = AUTOCOMPLETE[control.name];
      if (/name$/i.test(control.name)) control.setAttribute('autocapitalize', 'words');
      if (control.type === 'date') control.max = localToday();
      if (cfg.serialFields.indexOf(control.name) > -1 || control.name === 'Registration ID') {
        control.autocomplete = 'off';
        control.setAttribute('autocapitalize', 'characters');
        control.spellcheck = false;
      }
      if (cfg.groups && cfg.groups[control.name]) {
        var h3 = document.createElement('h3');
        h3.className = 'h3 zs-group';
        h3.textContent = cfg.groups[control.name];
        td.insertBefore(h3, td.firstChild);
      }
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-zs-ready')) return;
    var form = root.querySelector('form');
    if (!form) return;
    var cfg = FORMS[form.id];
    if (!cfg) return;
    root.setAttribute('data-zs-ready', '1');
    root.removeAttribute('align');
    transform(root, form, cfg);
    wireSubmit(root, form, cfg);
  }

  onReady(function () {
    document.querySelectorAll('#zohoSupportWebToCase').forEach(initRoot);
  });
  // Shopify theme editor re-renders the section (Zoho's inline script re-runs too).
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('#zohoSupportWebToCase').forEach(initRoot);
  });
})();
